webpackJsonp(["pipelines"],{

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/stage.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_icon_vue__ = __webpack_require__("./vue_shared/components/icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue__ = __webpack_require__("./vue_shared/components/loading_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");


/**
 * Renders each stage of the pipeline mini graph.
 *
 * Given the provided endpoint will make a request to
 * fetch the dropdown data when the stage is clicked.
 *
 * Request is made inside this component to make it reusable between:
 * 1. Pipelines main table
 * 2. Pipelines table in commit and Merge request views
 * 3. Merge request widget
 * 4. Commit widget
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    loadingIcon: __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue__["a" /* default */],
    icon: __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_icon_vue__["a" /* default */]
  },

  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_3__vue_shared_directives_tooltip__["a" /* default */]
  },

  props: {
    stage: {
      type: Object,
      required: true
    },

    updateDropdown: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function data() {
    return {
      isLoading: false,
      dropdownContent: ''
    };
  },


  computed: {
    dropdownClass: function dropdownClass() {
      return this.dropdownContent.length > 0 ? 'js-builds-dropdown-container' : 'js-builds-dropdown-loading';
    },
    triggerButtonClass: function triggerButtonClass() {
      return 'ci-status-icon-' + this.stage.status.group;
    },
    borderlessIcon: function borderlessIcon() {
      return this.stage.status.icon + '_borderless';
    }
  },

  watch: {
    updateDropdown: function updateDropdown() {
      if (this.updateDropdown && this.isDropdownOpen() && !this.isLoading) {
        this.fetchJobs();
      }
    }
  },

  updated: function updated() {
    if (this.dropdownContent.length > 0) {
      this.stopDropdownClickPropagation();
    }
  },


  methods: {
    onClickStage: function onClickStage() {
      if (!this.isDropdownOpen()) {
        this.isLoading = true;
        this.fetchJobs();
      }
    },
    fetchJobs: function fetchJobs() {
      var _this = this;

      this.$http.get(this.stage.dropdown_path).then(function (response) {
        return response.json();
      }).then(function (data) {
        _this.dropdownContent = data.html;
        _this.isLoading = false;
      }).catch(function () {
        _this.closeDropdown();
        _this.isLoading = false;

        var flash = new __WEBPACK_IMPORTED_MODULE_0__flash__["a" /* default */]('Something went wrong on our end.');
        return flash;
      });
    },


    /**
     * When the user right clicks or cmd/ctrl + click in the job name
     * the dropdown should not be closed and the link should open in another tab,
     * so we stop propagation of the click event inside the dropdown.
     *
     * Since this component is rendered multiple times per page we need to guarantee we only
     * target the click event of this component.
     */
    stopDropdownClickPropagation: function stopDropdownClickPropagation() {
      $(this.$el.querySelectorAll('.js-builds-dropdown-list a.mini-pipeline-graph-dropdown-item')).on('click', function (e) {
        e.stopPropagation();
      });
    },
    closeDropdown: function closeDropdown() {
      if (this.isDropdownOpen()) {
        $(this.$refs.dropdown).dropdown('toggle');
      }
    },
    isDropdownOpen: function isDropdownOpen() {
      return this.$el.classList.contains('open');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/visibilityjs/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../../../node_modules/visibilityjs/lib/visibility.timers.js")


/***/ }),

/***/ "../../../node_modules/visibilityjs/lib/visibility.core.js":
/***/ (function(module, exports) {

;(function (global) {
    "use strict";

    var lastId = -1;

    // Visibility.js allow you to know, that your web page is in the background
    // tab and thus not visible to the user. This library is wrap under
    // Page Visibility API. It fix problems with different vendor prefixes and
    // add high-level useful functions.
    var self = {

        // Call callback only when page become to visible for user or
        // call it now if page is visible now or Page Visibility API
        // doesn’t supported.
        //
        // Return false if API isn’t supported, true if page is already visible
        // or listener ID (you can use it in `unbind` method) if page isn’t
        // visible now.
        //
        //   Visibility.onVisible(function () {
        //       startIntroAnimation();
        //   });
        onVisible: function (callback) {
            var support = self.isSupported();
            if ( !support || !self.hidden() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( !self.hidden() ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Call callback when visibility will be changed. First argument for
        // callback will be original event object, second will be visibility
        // state name.
        //
        // Return listener ID to unbind listener by `unbind` method.
        //
        // If Page Visibility API doesn’t supported method will be return false
        // and callback never will be called.
        //
        //   Visibility.change(function(e, state) {
        //       Statistics.visibilityChange(state);
        //   });
        //
        // It is just proxy to `visibilitychange` event, but use vendor prefix.
        change: function (callback) {
            if ( !self.isSupported() ) {
                return false;
            }
            lastId += 1;
            var number = lastId;
            self._callbacks[number] = callback;
            self._listen();
            return number;
        },

        // Remove `change` listener by it ID.
        //
        //   var id = Visibility.change(function(e, state) {
        //       firstChangeCallback();
        //       Visibility.unbind(id);
        //   });
        unbind: function (id) {
            delete self._callbacks[id];
        },

        // Call `callback` in any state, expect “prerender”. If current state
        // is “prerender” it will wait until state will be changed.
        // If Page Visibility API doesn’t supported, it will call `callback`
        // immediately.
        //
        // Return false if API isn’t supported, true if page is already after
        // prerendering or listener ID (you can use it in `unbind` method)
        // if page is prerended now.
        //
        //   Visibility.afterPrerendering(function () {
        //       Statistics.countVisitor();
        //   });
        afterPrerendering: function (callback) {
            var support   = self.isSupported();
            var prerender = 'prerender';

            if ( !support || prerender != self.state() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( prerender != state ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Return true if page now isn’t visible to user.
        //
        //   if ( !Visibility.hidden() ) {
        //       VideoPlayer.play();
        //   }
        //
        // It is just proxy to `document.hidden`, but use vendor prefix.
        hidden: function () {
            return !!(self._doc.hidden || self._doc.webkitHidden);
        },

        // Return visibility state: 'visible', 'hidden' or 'prerender'.
        //
        //   if ( 'prerender' == Visibility.state() ) {
        //       Statistics.pageIsPrerendering();
        //   }
        //
        // Don’t use `Visibility.state()` to detect, is page visible, because
        // visibility states can extend in next API versions.
        // Use more simpler and general `Visibility.hidden()` for this cases.
        //
        // It is just proxy to `document.visibilityState`, but use
        // vendor prefix.
        state: function () {
            return self._doc.visibilityState       ||
                   self._doc.webkitVisibilityState ||
                   'visible';
        },

        // Return true if browser support Page Visibility API.
        //
        //   if ( Visibility.isSupported() ) {
        //       Statistics.startTrackingVisibility();
        //       Visibility.change(function(e, state)) {
        //           Statistics.trackVisibility(state);
        //       });
        //   }
        isSupported: function () {
            return !!(self._doc.visibilityState ||
                      self._doc.webkitVisibilityState);
        },

        // Link to document object to change it in tests.
        _doc: document || {},

        // Callbacks from `change` method, that wait visibility changes.
        _callbacks: { },

        // Listener for `visibilitychange` event.
        _change: function(event) {
            var state = self.state();

            for ( var i in self._callbacks ) {
                self._callbacks[i].call(self._doc, event, state);
            }
        },

        // Set listener for `visibilitychange` event.
        _listen: function () {
            if ( self._init ) {
                return;
            }

            var event = 'visibilitychange';
            if ( self._doc.webkitVisibilityState ) {
                event = 'webkit' + event;
            }

            var listener = function () {
                self._change.apply(self, arguments);
            };
            if ( self._doc.addEventListener ) {
                self._doc.addEventListener(event, listener);
            } else {
                self._doc.attachEvent(event, listener);
            }
            self._init = true;
        }

    };

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = self;
    } else {
        global.Visibility = self;
    }

})(this);


/***/ }),

/***/ "../../../node_modules/visibilityjs/lib/visibility.timers.js":
/***/ (function(module, exports, __webpack_require__) {

;(function (window) {
    "use strict";

    var lastTimer = -1;

    var install = function (Visibility) {

        // Run callback every `interval` milliseconds if page is visible and
        // every `hiddenInterval` milliseconds if page is hidden.
        //
        //   Visibility.every(60 * 1000, 5 * 60 * 1000, function () {
        //       checkNewMails();
        //   });
        //
        // You can skip `hiddenInterval` and callback will be called only if
        // page is visible.
        //
        //   Visibility.every(1000, function () {
        //       updateCountdown();
        //   });
        //
        // It is analog of `setInterval(callback, interval)` but use visibility
        // state.
        //
        // It return timer ID, that you can use in `Visibility.stop(id)` to stop
        // timer (`clearInterval` analog).
        // Warning: timer ID is different from interval ID from `setInterval`,
        // so don’t use it in `clearInterval`.
        //
        // On change state from hidden to visible timers will be execute.
        Visibility.every = function (interval, hiddenInterval, callback) {
            Visibility._time();

            if ( !callback ) {
                callback = hiddenInterval;
                hiddenInterval = null;
            }

            lastTimer += 1;
            var number = lastTimer;

            Visibility._timers[number] = {
                visible:  interval,
                hidden:   hiddenInterval,
                callback: callback
            };
            Visibility._run(number, false);

            if ( Visibility.isSupported() ) {
                Visibility._listen();
            }
            return number;
        };

        // Stop timer from `every` method by it ID (`every` method return it).
        //
        //   slideshow = Visibility.every(5 * 1000, function () {
        //       changeSlide();
        //   });
        //   $('.stopSlideshow').click(function () {
        //       Visibility.stop(slideshow);
        //   });
        Visibility.stop = function(id) {
            if ( !Visibility._timers[id] ) {
                return false;
            }
            Visibility._stop(id);
            delete Visibility._timers[id];
            return true;
        };

        // Callbacks and intervals added by `every` method.
        Visibility._timers = { };

        // Initialize variables on page loading.
        Visibility._time = function () {
            if ( Visibility._timed ) {
                return;
            }
            Visibility._timed     = true;
            Visibility._wasHidden = Visibility.hidden();

            Visibility.change(function () {
                Visibility._stopRun();
                Visibility._wasHidden = Visibility.hidden();
            });
        };

        // Try to run timer from every method by it’s ID. It will be use
        // `interval` or `hiddenInterval` depending on visibility state.
        // If page is hidden and `hiddenInterval` is null,
        // it will not run timer.
        //
        // Argument `runNow` say, that timers must be execute now too.
        Visibility._run = function (id, runNow) {
            var interval,
                timer = Visibility._timers[id];

            if ( Visibility.hidden() ) {
                if ( null === timer.hidden ) {
                    return;
                }
                interval = timer.hidden;
            } else {
                interval = timer.visible;
            }

            var runner = function () {
                timer.last = new Date();
                timer.callback.call(window);
            }

            if ( runNow ) {
                var now  = new Date();
                var last = now - timer.last ;

                if ( interval > last ) {
                    timer.delay = setTimeout(function () {
                        timer.id = setInterval(runner, interval);
                        runner();
                    }, interval - last);
                } else {
                    timer.id = setInterval(runner, interval);
                    runner();
                }

            } else {
              timer.id = setInterval(runner, interval);
            }
        };

        // Stop timer from `every` method by it’s ID.
        Visibility._stop = function (id) {
            var timer = Visibility._timers[id];
            clearInterval(timer.id);
            clearTimeout(timer.delay);
            delete timer.id;
            delete timer.delay;
        };

        // Listener for `visibilitychange` event.
        Visibility._stopRun = function (event) {
            var isHidden  = Visibility.hidden(),
                wasHidden = Visibility._wasHidden;

            if ( (isHidden && !wasHidden) || (!isHidden && wasHidden) ) {
                for ( var i in Visibility._timers ) {
                    Visibility._stop(i);
                    Visibility._run(i, !isHidden);
                }
            }
        };

        return Visibility;
    }

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = install(__webpack_require__("../../../node_modules/visibilityjs/lib/visibility.core.js"));
    } else {
        install(window.Visibility)
    }

})(window);


/***/ }),

/***/ "../../views/shared/icons/_icon_commit.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><path d=\"M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3.876-1.008a4.002 4.002 0 0 1-7.752 0A1.01 1.01 0 0 1 4 9H1a1 1 0 1 1 0-2h3c.042 0 .083.003.124.008a4.002 4.002 0 0 1 7.752 0A1.01 1.01 0 0 1 12 7h3a1 1 0 0 1 0 2h-3a1.01 1.01 0 0 1-.124-.008z\"/></svg>\n\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_timer.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" viewBox=\"0 0 40 40\"><g fill=\"#8F8F8F\" fill-rule=\"evenodd\"><path d=\"M29.513 10.134A15.922 15.922 0 0 0 23 7.28V6h2.993C26.55 6 27 5.552 27 5V2a1 1 0 0 0-1.007-1H14.007C13.45 1 13 1.448 13 2v3a1 1 0 0 0 1.007 1H17v1.28C9.597 8.686 4 15.19 4 23c0 8.837 7.163 16 16 16s16-7.163 16-16c0-3.461-1.099-6.665-2.967-9.283l1.327-1.58a2.498 2.498 0 0 0-.303-3.53 2.499 2.499 0 0 0-3.528.315l-1.016 1.212zM20 34c6.075 0 11-4.925 11-11s-4.925-11-11-11S9 16.925 9 23s4.925 11 11 11z\"/><path d=\"M19 21h-4.002c-.552 0-.998.452-.998 1.01v1.98c0 .567.447 1.01.998 1.01h7.004c.274 0 .521-.111.701-.291a.979.979 0 0 0 .297-.704v-8.01c0-.54-.452-.995-1.01-.995h-1.98a.997.997 0 0 0-1.01.995V21z\"/></g></svg>\n"

/***/ }),

/***/ "../images/no_avatar.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAAAAAAdJSU2AAACNElEQVR4AdXYBa7jMBCA4b3/JZahzIkjp2qt+BWUWnG5ln2XxaJJb2b5F2ukL4wvzK/rP7bUcbf92u6oftLSe1ldk8efsfaVeEjusZZeC6e1RllaCk/yG6ag1lZ4WwPX69uyD6tAe/g2ipAlNMRS37awDLaFrpcMWxXQOi0jnWCWjFkSZomYJWDWKmatYNZyEWkJsvQimoZYah5NgdaLxagCtF6GRy0DshZPkeYwS/KIJWGWYjwYUzDLxCwDtJ54OKglimBLqHWahii2g1pmHLLGBmwVoRjcKlmgOdw65H5qKuGWCVi5Qlhs6m1sENZi4q3AWNvca5UYy2RjT/SAsiZey6CsIvc0wVlV5lJ0ibPMyLUGCmlxQq0IM0hLdWyro7CWEc3sXsqaK4O2zLxOsmtpfW5Q1u68ZrVmepaaNXEewawtI9X5Xl3U3n1qND6+rfPzvqoIWz/fklNCSLY153YV53J/XUxGCJnKZ1lajsn3/Ffegf6Y5pV2LUsSNL2UHzxUfh3TlYpZqqTpXZm0KZk9zJcqaEmaWPHDw0pxe05K7bWOLHFLWXVetqpYmrjle4+1y0aBaF4UOQ1NU+lYezJClkjLUnSEjqhH6zjAW4OjtY39Ibq+sawUb6W2RQfoqG0VeKuwrRJvlba17faRdbe2pTtYq6Nty/S7yAbGsQjWIq41wVoT1+IdZNy1djUcVdu5lklQWC0xHkt1X31qNEE1Pr3qKv/9XiSNj6Aaifj3/69+AYujsR/MvkpZAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./lib/utils/http_status.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * exports HTTP status codes
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  ABORTED: 0,
  NO_CONTENT: 204,
  OK: 200,
  MULTIPLE_CHOICES: 300,
  BAD_REQUEST: 400
});

/***/ }),

/***/ "./lib/utils/poll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_status__ = __webpack_require__("./lib/utils/http_status.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




/**
 * Polling utility for handling realtime updates.
 * Requirements: Promise based HTTP client
 *
 * Service for promise based http client and method need to be provided as props
 *
 * @example
 * new Poll({
 *   resource: resource,
 *   method: 'name',
 *   data: {page: 1, scope: 'all'}, // optional
 *   successCallback: () => {},
 *   errorCallback: () => {},
 *   notificationCallback: () => {}, // optional
 * }).makeRequest();
 *
 * Usage in pipelines table with visibility lib:
 *
 * const poll = new Poll({
 *  resource: this.service,
 *  method: 'getPipelines',
 *  data: { page: pageNumber, scope },
 *  successCallback: this.successCallback,
 *  errorCallback: this.errorCallback,
 *  notificationCallback: this.updateLoading,
 * });
 *
 * if (!Visibility.hidden()) {
 *  poll.makeRequest();
 *  }
 *
 * Visibility.change(() => {
 *  if (!Visibility.hidden()) {
 *   poll.restart();
 *  } else {
 *   poll.stop();
 *  }
* });
 *
 * 1. Checks for response and headers before start polling
 * 2. Interval is provided by `Poll-Interval` header.
 * 3. If `Poll-Interval` is -1, we stop polling
 * 4. If HTTP response is 200, we poll.
 * 5. If HTTP response is different from 200, we stop polling.
 *
 */

var Poll = function () {
  function Poll() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Poll);

    this.options = options;
    this.options.data = options.data || {};
    this.options.notificationCallback = options.notificationCallback || function notificationCallback() {};

    this.intervalHeader = 'POLL-INTERVAL';
    this.timeoutID = null;
    this.canPoll = true;
  }

  _createClass(Poll, [{
    key: 'checkConditions',
    value: function checkConditions(response) {
      var _this = this;

      var headers = Object(__WEBPACK_IMPORTED_MODULE_1__common_utils__["u" /* normalizeHeaders */])(response.headers);
      var pollInterval = parseInt(headers[this.intervalHeader], 10);
      if (pollInterval > 0 && response.status === __WEBPACK_IMPORTED_MODULE_0__http_status__["a" /* default */].OK && this.canPoll) {
        this.timeoutID = setTimeout(function () {
          _this.makeRequest();
        }, pollInterval);
      }
      this.options.successCallback(response);
    }
  }, {
    key: 'makeRequest',
    value: function makeRequest() {
      var _this2 = this;

      var _options = this.options,
          resource = _options.resource,
          method = _options.method,
          data = _options.data,
          errorCallback = _options.errorCallback,
          notificationCallback = _options.notificationCallback;

      // It's called everytime a new request is made. Useful to update the status.

      notificationCallback(true);

      return resource[method](data).then(function (response) {
        _this2.checkConditions(response);
        notificationCallback(false);
      }).catch(function (error) {
        notificationCallback(false);
        if (error.status === __WEBPACK_IMPORTED_MODULE_0__http_status__["a" /* default */].ABORTED) {
          return;
        }
        errorCallback(error);
      });
    }

    /**
     * Stops the polling recursive chain
     * and guarantees if the timeout is already running it won't make another request by
     * cancelling the previously established timeout.
     */

  }, {
    key: 'stop',
    value: function stop() {
      this.canPoll = false;
      clearTimeout(this.timeoutID);
    }

    /**
     * Restarts polling after it has been stoped
     */

  }, {
    key: 'restart',
    value: function restart(options) {
      // update data
      if (options && options.data) {
        this.options.data = options.data;
      }

      this.canPoll = true;
      this.makeRequest();
    }
  }]);

  return Poll;
}();

/* harmony default export */ __webpack_exports__["a"] = (Poll);

/***/ }),

/***/ "./pipelines/components/stage.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/stage.vue
var stage = __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/stage.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f45d7fe","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/stage.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"mini-pipeline-graph-dropdown-toggle js-builds-dropdown-button",class:_vm.triggerButtonClass,attrs:{"title":_vm.stage.title,"data-placement":"top","data-toggle":"dropdown","type":"button","id":"stageDropdown","aria-haspopup":"true","aria-expanded":"false"},on:{"click":_vm.onClickStage}},[_c('span',{attrs:{"aria-hidden":"true","aria-label":_vm.stage.title}},[_c('icon',{attrs:{"name":_vm.borderlessIcon}})],1),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu mini-pipeline-graph-dropdown-menu js-builds-dropdown-container",attrs:{"aria-labelledby":"stageDropdown"}},[_c('li',{staticClass:"js-builds-dropdown-list scrollable-menu",class:_vm.dropdownClass},[(_vm.isLoading)?_c('loading-icon'):_c('ul',{domProps:{"innerHTML":_vm._s(_vm.dropdownContent)}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_stage = (esExports);
// CONCATENATED MODULE: ./pipelines/components/stage.vue
var normalizeComponent = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  stage["a" /* default */],
  components_stage,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pipelines_components_stage = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./pipelines/event_hub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),

/***/ "./pipelines/mixins/pipelines.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/visibilityjs/index.js
var visibilityjs = __webpack_require__("../../../node_modules/visibilityjs/index.js");
var visibilityjs_default = /*#__PURE__*/__webpack_require__.n(visibilityjs);

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./lib/utils/poll.js
var poll = __webpack_require__("./lib/utils/poll.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/empty_state.vue

/* harmony default export */ var empty_state = ({
  props: {
    helpPagePath: {
      type: String,
      required: true
    },
    emptyStateSvgPath: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90bae1f4","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/empty_state.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row empty-state js-empty-state"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"svg-content svg-250"},[_c('img',{attrs:{"src":_vm.emptyStateSvgPath}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"text-content"},[_c('h4',{staticClass:"text-center"},[_vm._v("\n          "+_vm._s(_vm.s__("Pipelines|Build with confidence"))+"\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          "+_vm._s(_vm.s__("Pipelines|Continous Integration can help\ncatch bugs by running your tests automatically,\nwhile Continuous Deployment can help you deliver code to your product environment."))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('a',{staticClass:"btn btn-info",attrs:{"href":_vm.helpPagePath}},[_vm._v("\n            "+_vm._s(_vm.s__("Pipelines|Get started with Pipelines"))+"\n          ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_empty_state = (esExports);
// CONCATENATED MODULE: ./pipelines/components/empty_state.vue
var normalizeComponent = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  empty_state,
  components_empty_state,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pipelines_components_empty_state = (Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/error_state.vue

/* harmony default export */ var error_state = ({
  props: {
    errorStateSvgPath: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-549f68aa","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/error_state.vue
var error_state_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row empty-state js-pipelines-error-state"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"svg-content"},[_c('img',{attrs:{"src":_vm.errorStateSvgPath}})])]),_vm._v(" "),_vm._m(0)])}
var error_state_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 text-center"},[_c('div',{staticClass:"text-content"},[_c('h4',[_vm._v("API 获取流水线失败。")])])])}]
var error_state_esExports = { render: error_state_render, staticRenderFns: error_state_staticRenderFns }
/* harmony default export */ var components_error_state = (error_state_esExports);
// CONCATENATED MODULE: ./pipelines/components/error_state.vue
var error_state_normalizeComponent = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")
/* script */


/* template */

/* template functional */
var error_state___vue_template_functional__ = false
/* styles */
var error_state___vue_styles__ = null
/* scopeId */
var error_state___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var error_state___vue_module_identifier__ = null
var error_state_Component = error_state_normalizeComponent(
  error_state,
  components_error_state,
  error_state___vue_template_functional__,
  error_state___vue_styles__,
  error_state___vue_scopeId__,
  error_state___vue_module_identifier__
)

/* harmony default export */ var pipelines_components_error_state = (error_state_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// EXTERNAL MODULE: ./pipelines/event_hub.js
var event_hub = __webpack_require__("./pipelines/event_hub.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/async_button.vue

/* eslint-disable no-alert */






/* harmony default export */ var async_button = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    loadingIcon: loading_icon["a" /* default */],
    icon: icon["a" /* default */]
  },
  props: {
    endpoint: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    cssClass: {
      type: String,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: false
    };
  },

  computed: {
    buttonClass: function buttonClass() {
      return 'btn ' + this.cssClass;
    }
  },
  methods: {
    onClick: function onClick() {
      event_hub["a" /* default */].$emit('actionConfirmationModal', {
        id: this.id,
        callback: this.makeRequest
      });
    },
    makeRequest: function makeRequest() {
      this.isLoading = true;

      event_hub["a" /* default */].$emit('postAction', this.endpoint);
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1db3f8ea","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/async_button.vue
var async_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.buttonClass,attrs:{"type":"button","title":_vm.title,"aria-label":_vm.title,"data-container":"body","data-placement":"top","disabled":_vm.isLoading},on:{"click":_vm.onClick}},[_c('icon',{attrs:{"name":_vm.icon}}),_vm._v(" "),(_vm.isLoading)?_c('loading-icon'):_vm._e()],1)}
var async_button_staticRenderFns = []
var async_button_esExports = { render: async_button_render, staticRenderFns: async_button_staticRenderFns }
/* harmony default export */ var components_async_button = (async_button_esExports);
// CONCATENATED MODULE: ./pipelines/components/async_button.vue
var async_button_normalizeComponent = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")
/* script */


/* template */

/* template functional */
var async_button___vue_template_functional__ = false
/* styles */
var async_button___vue_styles__ = null
/* scopeId */
var async_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var async_button___vue_module_identifier__ = null
var async_button_Component = async_button_normalizeComponent(
  async_button,
  components_async_button,
  async_button___vue_template_functional__,
  async_button___vue_styles__,
  async_button___vue_scopeId__,
  async_button___vue_module_identifier__
)

/* harmony default export */ var pipelines_components_async_button = (async_button_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_actions.vue






/* harmony default export */ var pipelines_actions = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    loadingIcon: loading_icon["a" /* default */],
    icon: icon["a" /* default */]
  },
  props: {
    actions: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: false
    };
  },

  methods: {
    onClickAction: function onClickAction(endpoint) {
      this.isLoading = true;

      event_hub["a" /* default */].$emit('postAction', endpoint);
    },
    isActionDisabled: function isActionDisabled(action) {
      if (action.playable === undefined) {
        return false;
      }

      return !action.playable;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4131da4d","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_actions.vue
var pipelines_actions_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"dropdown-new btn btn-default js-pipeline-dropdown-manual-actions",attrs:{"type":"button","title":"Manual job","data-toggle":"dropdown","data-placement":"top","aria-label":"Manual job","disabled":_vm.isLoading}},[_c('icon',{staticClass:"icon-play",attrs:{"name":"play"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.isLoading)?_c('loading-icon'):_vm._e()],1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-menu-align-right"},_vm._l((_vm.actions),function(action,i){return _c('li',{key:i},[_c('button',{staticClass:"js-pipeline-action-link no-btn btn",class:{ disabled: _vm.isActionDisabled(action) },attrs:{"type":"button","disabled":_vm.isActionDisabled(action)},on:{"click":function($event){_vm.onClickAction(action.path)}}},[_vm._v("\n        "+_vm._s(action.name)+"\n      ")])])}))])}
var pipelines_actions_staticRenderFns = []
var pipelines_actions_esExports = { render: pipelines_actions_render, staticRenderFns: pipelines_actions_staticRenderFns }
/* harmony default export */ var components_pipelines_actions = (pipelines_actions_esExports);
// CONCATENATED MODULE: ./pipelines/components/pipelines_actions.vue
var pipelines_actions_normalizeComponent = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")
/* script */


/* template */

/* template functional */
var pipelines_actions___vue_template_functional__ = false
/* styles */
var pipelines_actions___vue_styles__ = null
/* scopeId */
var pipelines_actions___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines_actions___vue_module_identifier__ = null
var pipelines_actions_Component = pipelines_actions_normalizeComponent(
  pipelines_actions,
  components_pipelines_actions,
  pipelines_actions___vue_template_functional__,
  pipelines_actions___vue_styles__,
  pipelines_actions___vue_scopeId__,
  pipelines_actions___vue_module_identifier__
)

/* harmony default export */ var pipelines_components_pipelines_actions = (pipelines_actions_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_artifacts.vue




/* harmony default export */ var pipelines_artifacts = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    icon: icon["a" /* default */]
  },
  props: {
    artifacts: {
      type: Array,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8577a5a6","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_artifacts.vue
var pipelines_artifacts_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"dropdown-toggle btn btn-default build-artifacts js-pipeline-dropdown-download",attrs:{"title":"Artifacts","data-placement":"top","data-toggle":"dropdown","aria-label":"Artifacts"}},[_c('icon',{attrs:{"name":"download"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}})],1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-menu-align-right"},_vm._l((_vm.artifacts),function(artifact,i){return _c('li',{key:i},[_c('a',{attrs:{"rel":"nofollow","download":"","href":artifact.path}},[_vm._v("\n        Download "+_vm._s(artifact.name)+" artifacts\n      ")])])}))])}
var pipelines_artifacts_staticRenderFns = []
var pipelines_artifacts_esExports = { render: pipelines_artifacts_render, staticRenderFns: pipelines_artifacts_staticRenderFns }
/* harmony default export */ var components_pipelines_artifacts = (pipelines_artifacts_esExports);
// CONCATENATED MODULE: ./pipelines/components/pipelines_artifacts.vue
var pipelines_artifacts_normalizeComponent = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")
/* script */


/* template */

/* template functional */
var pipelines_artifacts___vue_template_functional__ = false
/* styles */
var pipelines_artifacts___vue_styles__ = null
/* scopeId */
var pipelines_artifacts___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines_artifacts___vue_module_identifier__ = null
var pipelines_artifacts_Component = pipelines_artifacts_normalizeComponent(
  pipelines_artifacts,
  components_pipelines_artifacts,
  pipelines_artifacts___vue_template_functional__,
  pipelines_artifacts___vue_styles__,
  pipelines_artifacts___vue_scopeId__,
  pipelines_artifacts___vue_module_identifier__
)

/* harmony default export */ var pipelines_components_pipelines_artifacts = (pipelines_artifacts_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/ci_badge_link.vue + 2 modules
var ci_badge_link = __webpack_require__("./vue_shared/components/ci_badge_link.vue");

// EXTERNAL MODULE: ./pipelines/components/stage.vue + 1 modules
var stage = __webpack_require__("./pipelines/components/stage.vue");

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_link.vue + 2 modules
var user_avatar_link = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_link.vue");

// EXTERNAL MODULE: ./vue_shared/directives/popover.js
var popover = __webpack_require__("./vue_shared/directives/popover.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipeline_url.vue





/* harmony default export */ var pipeline_url = ({
  components: {
    userAvatarLink: user_avatar_link["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */],
    popover: popover["a" /* default */]
  },
  props: {
    pipeline: {
      type: Object,
      required: true
    },
    autoDevopsHelpPath: {
      type: String,
      required: true
    }
  },
  computed: {
    user: function user() {
      return this.pipeline.user;
    },
    popoverOptions: function popoverOptions() {
      return {
        html: true,
        trigger: 'focus',
        placement: 'top',
        title: '<div class="autodevops-title">\n          This pipeline makes use of a predefined CI/CD configuration enabled by <b>Auto DevOps.</b>\n        </div>',
        content: '<a\n          class="autodevops-link"\n          href="' + this.autoDevopsHelpPath + '"\n          target="_blank"\n          rel="noopener noreferrer nofollow">\n          Learn more about Auto DevOps\n        </a>'
      };
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cea8c848","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipeline_url.vue
var pipeline_url_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-section section-15 hidden-xs hidden-sm pipeline-tags"},[_c('a',{staticClass:"js-pipeline-url-link",attrs:{"href":_vm.pipeline.path}},[_c('span',{staticClass:"pipeline-id"},[_vm._v("#"+_vm._s(_vm.pipeline.id))])]),_vm._v(" "),_c('span',[_vm._v("by")]),_vm._v(" "),(_vm.user)?_c('user-avatar-link',{staticClass:"js-pipeline-url-user",attrs:{"link-href":_vm.pipeline.user.path,"img-src":_vm.pipeline.user.avatar_url,"tooltip-text":_vm.pipeline.user.name}}):_vm._e(),_vm._v(" "),(!_vm.user)?_c('span',{staticClass:"js-pipeline-url-api api"},[_vm._v("\n    API\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"label-container"},[(_vm.pipeline.flags.latest)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"js-pipeline-url-latest label label-success",attrs:{"title":"Latest pipeline for this branch"}},[_vm._v("\n      latest\n    ")]):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.yaml_errors)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"js-pipeline-url-yaml label label-danger",attrs:{"title":_vm.pipeline.yaml_errors}},[_vm._v("\n      yaml invalid\n    ")]):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.failure_reason)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"js-pipeline-url-failure label label-danger",attrs:{"title":_vm.pipeline.failure_reason}},[_vm._v("\n      error\n    ")]):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.auto_devops)?_c('a',{directives:[{name:"popover",rawName:"v-popover",value:(_vm.popoverOptions),expression:"popoverOptions"}],staticClass:"js-pipeline-url-autodevops label label-info autodevops-badge",attrs:{"tabindex":"0","role":"button"}},[_vm._v("\n      Auto DevOps\n    ")]):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.stuck)?_c('span',{staticClass:"js-pipeline-url-stuck label label-warning"},[_vm._v("\n      stuck\n    ")]):_vm._e()])],1)}
var pipeline_url_staticRenderFns = []
var pipeline_url_esExports = { render: pipeline_url_render, staticRenderFns: pipeline_url_staticRenderFns }
/* harmony default export */ var components_pipeline_url = (pipeline_url_esExports);
// CONCATENATED MODULE: ./pipelines/components/pipeline_url.vue
var pipeline_url_normalizeComponent = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")
/* script */


/* template */

/* template functional */
var pipeline_url___vue_template_functional__ = false
/* styles */
var pipeline_url___vue_styles__ = null
/* scopeId */
var pipeline_url___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipeline_url___vue_module_identifier__ = null
var pipeline_url_Component = pipeline_url_normalizeComponent(
  pipeline_url,
  components_pipeline_url,
  pipeline_url___vue_template_functional__,
  pipeline_url___vue_styles__,
  pipeline_url___vue_scopeId__,
  pipeline_url___vue_module_identifier__
)

/* harmony default export */ var pipelines_components_pipeline_url = (pipeline_url_Component.exports);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_timer.svg
var _icon_timer = __webpack_require__("../../views/shared/icons/_icon_timer.svg");
var _icon_timer_default = /*#__PURE__*/__webpack_require__.n(_icon_timer);

// EXTERNAL MODULE: ./lib/utils/datetime_utility.js
var datetime_utility = __webpack_require__("./lib/utils/datetime_utility.js");

// EXTERNAL MODULE: ./vue_shared/mixins/timeago.js
var timeago = __webpack_require__("./vue_shared/mixins/timeago.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/time_ago.vue






/* harmony default export */ var time_ago = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  mixins: [timeago["a" /* default */]],
  props: {
    finishedTime: {
      type: String,
      required: true
    },
    duration: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      iconTimerSvg: _icon_timer_default.a
    };
  },

  computed: {
    hasDuration: function hasDuration() {
      return this.duration > 0;
    },
    hasFinishedTime: function hasFinishedTime() {
      return this.finishedTime !== '';
    },
    durationFormated: function durationFormated() {
      var date = new Date(this.duration * 1000);

      var hh = date.getUTCHours();
      var mm = date.getUTCMinutes();
      var ss = date.getSeconds();

      // left pad
      if (hh < 10) {
        hh = '0' + hh;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      if (ss < 10) {
        ss = '0' + ss;
      }

      return hh + ':' + mm + ':' + ss;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-369bf334","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/time_ago.vue
var time_ago_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-section section-15 pipelines-time-ago"},[_c('div',{staticClass:"table-mobile-header",attrs:{"role":"rowheader"}},[_vm._v("\n    持续时间\n  ")]),_vm._v(" "),_c('div',{staticClass:"table-mobile-content"},[(_vm.hasDuration)?_c('p',{staticClass:"duration"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.iconTimerSvg)}}),_vm._v("\n      "+_vm._s(_vm.durationFormated)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.hasFinishedTime)?_c('p',{staticClass:"finished-at hidden-xs hidden-sm"},[_c('i',{staticClass:"fa fa-calendar",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('time',{directives:[{name:"tooltip",rawName:"v-tooltip"}],attrs:{"data-placement":"top","data-container":"body","title":_vm.tooltipTitle(_vm.finishedTime)}},[_vm._v("\n        "+_vm._s(_vm.timeFormated(_vm.finishedTime))+"\n      ")])]):_vm._e()])])}
var time_ago_staticRenderFns = []
var time_ago_esExports = { render: time_ago_render, staticRenderFns: time_ago_staticRenderFns }
/* harmony default export */ var components_time_ago = (time_ago_esExports);
// CONCATENATED MODULE: ./pipelines/components/time_ago.vue
var time_ago_normalizeComponent = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")
/* script */


/* template */

/* template functional */
var time_ago___vue_template_functional__ = false
/* styles */
var time_ago___vue_styles__ = null
/* scopeId */
var time_ago___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var time_ago___vue_module_identifier__ = null
var time_ago_Component = time_ago_normalizeComponent(
  time_ago,
  components_time_ago,
  time_ago___vue_template_functional__,
  time_ago___vue_styles__,
  time_ago___vue_scopeId__,
  time_ago___vue_module_identifier__
)

/* harmony default export */ var pipelines_components_time_ago = (time_ago_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/commit.vue + 2 modules
var commit = __webpack_require__("./vue_shared/components/commit.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_table_row.vue

/* eslint-disable no-param-reassign */









/**
 * Pipeline table row.
 *
 * Given the received object renders a table row in the pipelines' table.
 */
/* harmony default export */ var pipelines_table_row = ({
  components: {
    asyncButtonComponent: pipelines_components_async_button,
    pipelinesActionsComponent: pipelines_components_pipelines_actions,
    pipelinesArtifactsComponent: pipelines_components_pipelines_artifacts,
    commitComponent: commit["a" /* default */],
    pipelineStage: stage["a" /* default */],
    pipelineUrl: pipelines_components_pipeline_url,
    ciBadge: ci_badge_link["a" /* default */],
    pipelinesTimeago: pipelines_components_time_ago
  },
  props: {
    pipeline: {
      type: Object,
      required: true
    },
    updateGraphDropdown: {
      type: Boolean,
      required: false,
      default: false
    },
    autoDevopsHelpPath: {
      type: String,
      required: true
    },
    viewType: {
      type: String,
      required: true
    }
  },
  computed: {
    /**
     * If provided, returns the commit tag.
     * Needed to render the commit component column.
     *
     * This field needs a lot of verification, because of different possible cases:
     *
     * 1. person who is an author of a commit might be a GitLab user
     * 2. if person who is an author of a commit is a GitLab user he/she can have a GitLab avatar
     * 3. If GitLab user does not have avatar he/she might have a Gravatar
     * 4. If committer is not a GitLab User he/she can have a Gravatar
     * 5. We do not have consistent API object in this case
     * 6. We should improve API and the code
     *
     * @returns {Object|Undefined}
     */
    commitAuthor: function commitAuthor() {
      var commitAuthorInformation = void 0;

      if (!this.pipeline || !this.pipeline.commit) {
        return null;
      }

      // 1. person who is an author of a commit might be a GitLab user
      if (this.pipeline.commit.author) {
        // 2. if person who is an author of a commit is a GitLab user
        // he/she can have a GitLab avatar
        if (this.pipeline.commit.author.avatar_url) {
          commitAuthorInformation = this.pipeline.commit.author;

          // 3. If GitLab user does not have avatar he/she might have a Gravatar
        } else if (this.pipeline.commit.author_gravatar_url) {
          commitAuthorInformation = Object.assign({}, this.pipeline.commit.author, {
            avatar_url: this.pipeline.commit.author_gravatar_url
          });
        }
        // 4. If committer is not a GitLab User he/she can have a Gravatar
      } else {
        commitAuthorInformation = {
          avatar_url: this.pipeline.commit.author_gravatar_url,
          path: 'mailto:' + this.pipeline.commit.author_email,
          username: this.pipeline.commit.author_name
        };
      }

      return commitAuthorInformation;
    },


    /**
     * If provided, returns the commit tag.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitTag: function commitTag() {
      if (this.pipeline.ref && this.pipeline.ref.tag) {
        return this.pipeline.ref.tag;
      }
      return undefined;
    },


    /**
     * If provided, returns the commit ref.
     * Needed to render the commit component column.
     *
     * Matches `path` prop sent in the API to `ref_url` prop needed
     * in the commit component.
     *
     * @returns {Object|Undefined}
     */
    commitRef: function commitRef() {
      var _this = this;

      if (this.pipeline.ref) {
        return Object.keys(this.pipeline.ref).reduce(function (accumulator, prop) {
          if (prop === 'path') {
            accumulator.ref_url = _this.pipeline.ref[prop];
          } else {
            accumulator[prop] = _this.pipeline.ref[prop];
          }
          return accumulator;
        }, {});
      }

      return undefined;
    },


    /**
     * If provided, returns the commit url.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitUrl: function commitUrl() {
      if (this.pipeline.commit && this.pipeline.commit.commit_path) {
        return this.pipeline.commit.commit_path;
      }
      return undefined;
    },


    /**
     * If provided, returns the commit short sha.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitShortSha: function commitShortSha() {
      if (this.pipeline.commit && this.pipeline.commit.short_id) {
        return this.pipeline.commit.short_id;
      }
      return undefined;
    },


    /**
     * If provided, returns the commit title.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitTitle: function commitTitle() {
      if (this.pipeline.commit && this.pipeline.commit.title) {
        return this.pipeline.commit.title;
      }
      return undefined;
    },


    /**
     * Timeago components expects a number
     *
     * @return {type}  description
     */
    pipelineDuration: function pipelineDuration() {
      if (this.pipeline.details && this.pipeline.details.duration) {
        return this.pipeline.details.duration;
      }

      return 0;
    },


    /**
     * Timeago component expects a String.
     *
     * @return {String}
     */
    pipelineFinishedAt: function pipelineFinishedAt() {
      if (this.pipeline.details && this.pipeline.details.finished_at) {
        return this.pipeline.details.finished_at;
      }

      return '';
    },
    pipelineStatus: function pipelineStatus() {
      if (this.pipeline.details && this.pipeline.details.status) {
        return this.pipeline.details.status;
      }
      return {};
    },
    displayPipelineActions: function displayPipelineActions() {
      return this.pipeline.flags.retryable || this.pipeline.flags.cancelable || this.pipeline.details.manual_actions.length || this.pipeline.details.artifacts.length;
    },
    isChildView: function isChildView() {
      return this.viewType === 'child';
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72d7274a","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_table_row.vue
var pipelines_table_row_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commit gl-responsive-table-row"},[_c('div',{staticClass:"table-section section-10 commit-link"},[_c('div',{staticClass:"table-mobile-header",attrs:{"role":"rowheader"}},[_vm._v("\n      Status\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-mobile-content"},[_c('ci-badge',{attrs:{"status":_vm.pipelineStatus,"show-text":!_vm.isChildView}})],1)]),_vm._v(" "),_c('pipeline-url',{attrs:{"pipeline":_vm.pipeline,"auto-devops-help-path":_vm.autoDevopsHelpPath}}),_vm._v(" "),_c('div',{staticClass:"table-section section-20"},[_c('div',{staticClass:"table-mobile-header",attrs:{"role":"rowheader"}},[_vm._v("\n      Commit\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-mobile-content"},[_c('commit-component',{attrs:{"tag":_vm.commitTag,"commit-ref":_vm.commitRef,"commit-url":_vm.commitUrl,"short-sha":_vm.commitShortSha,"title":_vm.commitTitle,"author":_vm.commitAuthor,"show-branch":!_vm.isChildView}})],1)]),_vm._v(" "),_c('div',{staticClass:"table-section section-wrap section-20 stage-cell"},[_c('div',{staticClass:"table-mobile-header",attrs:{"role":"rowheader"}},[_vm._v("\n      Stages\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-mobile-content"},[(_vm.pipeline.details.stages.length > 0)?_vm._l((_vm.pipeline.details.stages),function(stage,index){return _c('div',{key:index,staticClass:"stage-container dropdown js-mini-pipeline-graph"},[_c('pipeline-stage',{attrs:{"stage":stage,"update-dropdown":_vm.updateGraphDropdown}})],1)}):_vm._e()],2)]),_vm._v(" "),_c('pipelines-timeago',{attrs:{"duration":_vm.pipelineDuration,"finished-time":_vm.pipelineFinishedAt}}),_vm._v(" "),(_vm.displayPipelineActions)?_c('div',{staticClass:"table-section section-20 table-button-footer pipeline-actions"},[_c('div',{staticClass:"btn-group table-action-buttons"},[(_vm.pipeline.details.manual_actions.length)?_c('pipelines-actions-component',{attrs:{"actions":_vm.pipeline.details.manual_actions}}):_vm._e(),_vm._v(" "),(_vm.pipeline.details.artifacts.length)?_c('pipelines-artifacts-component',{staticClass:"hidden-xs hidden-sm",attrs:{"artifacts":_vm.pipeline.details.artifacts}}):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.retryable)?_c('async-button-component',{attrs:{"endpoint":_vm.pipeline.retry_path,"css-class":"js-pipelines-retry-button btn-default btn-retry","title":"Retry","icon":"repeat","id":_vm.pipeline.id,"data-toggle":"modal","data-target":"#retry-confirmation-modal"}}):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.cancelable)?_c('async-button-component',{attrs:{"endpoint":_vm.pipeline.cancel_path,"css-class":"js-pipelines-cancel-button btn-remove","title":"Cancel","icon":"close","id":_vm.pipeline.id,"data-toggle":"modal","data-target":"#stop-confirmation-modal"}}):_vm._e()],1)]):_vm._e()],1)}
var pipelines_table_row_staticRenderFns = []
var pipelines_table_row_esExports = { render: pipelines_table_row_render, staticRenderFns: pipelines_table_row_staticRenderFns }
/* harmony default export */ var components_pipelines_table_row = (pipelines_table_row_esExports);
// CONCATENATED MODULE: ./pipelines/components/pipelines_table_row.vue
var pipelines_table_row_normalizeComponent = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")
/* script */


/* template */

/* template functional */
var pipelines_table_row___vue_template_functional__ = false
/* styles */
var pipelines_table_row___vue_styles__ = null
/* scopeId */
var pipelines_table_row___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines_table_row___vue_module_identifier__ = null
var pipelines_table_row_Component = pipelines_table_row_normalizeComponent(
  pipelines_table_row,
  components_pipelines_table_row,
  pipelines_table_row___vue_template_functional__,
  pipelines_table_row___vue_styles__,
  pipelines_table_row___vue_scopeId__,
  pipelines_table_row___vue_module_identifier__
)

/* harmony default export */ var pipelines_components_pipelines_table_row = (pipelines_table_row_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/modal.vue + 2 modules
var modal = __webpack_require__("./vue_shared/components/modal.vue");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/stop_confirmation_modal.vue





/* harmony default export */ var stop_confirmation_modal = ({
  components: {
    modal: modal["a" /* default */]
  },
  data: function data() {
    return {
      id: '',
      callback: function callback() {}
    };
  },

  computed: {
    title: function title() {
      return Object(locale["sprintf"])(Object(locale["s__"])('Pipeline|Stop pipeline #%{id}?'), {
        id: '\'' + this.id + '\''
      }, false);
    },
    text: function text() {
      return Object(locale["sprintf"])(Object(locale["s__"])('Pipeline|You’re about to stop pipeline %{id}.'), {
        id: '<strong>#' + this.id + '</strong>'
      }, false);
    },
    primaryButtonLabel: function primaryButtonLabel() {
      return Object(locale["s__"])('Pipeline|Stop pipeline');
    }
  },
  created: function created() {
    event_hub["a" /* default */].$on('actionConfirmationModal', this.updateModal);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('actionConfirmationModal', this.updateModal);
  },

  methods: {
    updateModal: function updateModal(action) {
      this.id = action.id;
      this.callback = action.callback;
    },
    onSubmit: function onSubmit() {
      this.callback();
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79e28ff8","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/stop_confirmation_modal.vue
var stop_confirmation_modal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"id":"stop-confirmation-modal","title":_vm.title,"text":_vm.text,"kind":"danger","primary-button-label":_vm.primaryButtonLabel},on:{"submit":_vm.onSubmit},scopedSlots:_vm._u([{key:"body",fn:function(props){return [_c('p',{domProps:{"innerHTML":_vm._s(props.text)}})]}}])})}
var stop_confirmation_modal_staticRenderFns = []
var stop_confirmation_modal_esExports = { render: stop_confirmation_modal_render, staticRenderFns: stop_confirmation_modal_staticRenderFns }
/* harmony default export */ var components_stop_confirmation_modal = (stop_confirmation_modal_esExports);
// CONCATENATED MODULE: ./pipelines/components/stop_confirmation_modal.vue
var stop_confirmation_modal_normalizeComponent = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")
/* script */


/* template */

/* template functional */
var stop_confirmation_modal___vue_template_functional__ = false
/* styles */
var stop_confirmation_modal___vue_styles__ = null
/* scopeId */
var stop_confirmation_modal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var stop_confirmation_modal___vue_module_identifier__ = null
var stop_confirmation_modal_Component = stop_confirmation_modal_normalizeComponent(
  stop_confirmation_modal,
  components_stop_confirmation_modal,
  stop_confirmation_modal___vue_template_functional__,
  stop_confirmation_modal___vue_styles__,
  stop_confirmation_modal___vue_scopeId__,
  stop_confirmation_modal___vue_module_identifier__
)

/* harmony default export */ var pipelines_components_stop_confirmation_modal = (stop_confirmation_modal_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/retry_confirmation_modal.vue





/* harmony default export */ var retry_confirmation_modal = ({
  components: {
    modal: modal["a" /* default */]
  },
  data: function data() {
    return {
      id: '',
      callback: function callback() {}
    };
  },

  computed: {
    title: function title() {
      return Object(locale["sprintf"])(Object(locale["s__"])('Pipeline|Retry pipeline #%{id}?'), {
        id: '\'' + this.id + '\''
      }, false);
    },
    text: function text() {
      return Object(locale["sprintf"])(Object(locale["s__"])('Pipeline|You’re about to retry pipeline %{id}.'), {
        id: '<strong>#' + this.id + '</strong>'
      }, false);
    },
    primaryButtonLabel: function primaryButtonLabel() {
      return Object(locale["s__"])('Pipeline|Retry pipeline');
    }
  },
  created: function created() {
    event_hub["a" /* default */].$on('actionConfirmationModal', this.updateModal);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('actionConfirmationModal', this.updateModal);
  },

  methods: {
    updateModal: function updateModal(action) {
      this.id = action.id;
      this.callback = action.callback;
    },
    onSubmit: function onSubmit() {
      this.callback();
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a735b6a","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/retry_confirmation_modal.vue
var retry_confirmation_modal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"id":"retry-confirmation-modal","title":_vm.title,"text":_vm.text,"kind":"danger","primary-button-label":_vm.primaryButtonLabel},on:{"submit":_vm.onSubmit},scopedSlots:_vm._u([{key:"body",fn:function(props){return [_c('p',{domProps:{"innerHTML":_vm._s(props.text)}})]}}])})}
var retry_confirmation_modal_staticRenderFns = []
var retry_confirmation_modal_esExports = { render: retry_confirmation_modal_render, staticRenderFns: retry_confirmation_modal_staticRenderFns }
/* harmony default export */ var components_retry_confirmation_modal = (retry_confirmation_modal_esExports);
// CONCATENATED MODULE: ./pipelines/components/retry_confirmation_modal.vue
var retry_confirmation_modal_normalizeComponent = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")
/* script */


/* template */

/* template functional */
var retry_confirmation_modal___vue_template_functional__ = false
/* styles */
var retry_confirmation_modal___vue_styles__ = null
/* scopeId */
var retry_confirmation_modal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var retry_confirmation_modal___vue_module_identifier__ = null
var retry_confirmation_modal_Component = retry_confirmation_modal_normalizeComponent(
  retry_confirmation_modal,
  components_retry_confirmation_modal,
  retry_confirmation_modal___vue_template_functional__,
  retry_confirmation_modal___vue_styles__,
  retry_confirmation_modal___vue_scopeId__,
  retry_confirmation_modal___vue_module_identifier__
)

/* harmony default export */ var pipelines_components_retry_confirmation_modal = (retry_confirmation_modal_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_table.vue





/**
 * Pipelines Table Component.
 *
 * Given an array of objects, renders a table.
 */
/* harmony default export */ var pipelines_table = ({
  components: {
    pipelinesTableRowComponent: pipelines_components_pipelines_table_row,
    stopConfirmationModal: pipelines_components_stop_confirmation_modal,
    retryConfirmationModal: pipelines_components_retry_confirmation_modal
  },
  props: {
    pipelines: {
      type: Array,
      required: true
    },
    updateGraphDropdown: {
      type: Boolean,
      required: false,
      default: false
    },
    autoDevopsHelpPath: {
      type: String,
      required: true
    },
    viewType: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9f0a798","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_table.vue
var pipelines_table_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ci-table"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.pipelines),function(model){return _c('pipelines-table-row-component',{key:model.id,attrs:{"pipeline":model,"update-graph-dropdown":_vm.updateGraphDropdown,"auto-devops-help-path":_vm.autoDevopsHelpPath,"view-type":_vm.viewType}})}),_vm._v(" "),_c('stop-confirmation-modal'),_vm._v(" "),_c('retry-confirmation-modal')],2)}
var pipelines_table_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gl-responsive-table-row table-row-header",attrs:{"role":"row"}},[_c('div',{staticClass:"table-section section-10 js-pipeline-status pipeline-status",attrs:{"role":"rowheader"}},[_vm._v("\n      状态\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-section section-15 js-pipeline-info pipeline-info",attrs:{"role":"rowheader"}},[_vm._v("\n      流水线\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-section section-20 js-pipeline-commit pipeline-commit",attrs:{"role":"rowheader"}},[_vm._v("\n      提交\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-section section-20 js-pipeline-stages pipeline-stages",attrs:{"role":"rowheader"}},[_vm._v("\n      步骤\n    ")])])}]
var pipelines_table_esExports = { render: pipelines_table_render, staticRenderFns: pipelines_table_staticRenderFns }
/* harmony default export */ var components_pipelines_table = (pipelines_table_esExports);
// CONCATENATED MODULE: ./pipelines/components/pipelines_table.vue
var pipelines_table_normalizeComponent = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")
/* script */


/* template */

/* template functional */
var pipelines_table___vue_template_functional__ = false
/* styles */
var pipelines_table___vue_styles__ = null
/* scopeId */
var pipelines_table___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines_table___vue_module_identifier__ = null
var pipelines_table_Component = pipelines_table_normalizeComponent(
  pipelines_table,
  components_pipelines_table,
  pipelines_table___vue_template_functional__,
  pipelines_table___vue_styles__,
  pipelines_table___vue_scopeId__,
  pipelines_table___vue_module_identifier__
)

/* harmony default export */ var pipelines_components_pipelines_table = (pipelines_table_Component.exports);

// CONCATENATED MODULE: ./pipelines/mixins/pipelines.js









/* harmony default export */ var pipelines = __webpack_exports__["a"] = ({
  components: {
    pipelinesTableComponent: pipelines_components_pipelines_table,
    errorState: pipelines_components_error_state,
    emptyState: pipelines_components_empty_state,
    loadingIcon: loading_icon["a" /* default */]
  },
  computed: {
    shouldRenderErrorState: function shouldRenderErrorState() {
      return this.hasError && !this.isLoading;
    }
  },
  data: function data() {
    return {
      isLoading: false,
      hasError: false,
      isMakingRequest: false,
      updateGraphDropdown: false,
      hasMadeRequest: false
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.poll = new poll["a" /* default */]({
      resource: this.service,
      method: 'getPipelines',
      data: this.requestData ? this.requestData : undefined,
      successCallback: this.successCallback,
      errorCallback: this.errorCallback,
      notificationCallback: this.setIsMakingRequest
    });

    if (!visibilityjs_default.a.hidden()) {
      this.isLoading = true;
      this.poll.makeRequest();
    } else {
      // If tab is not visible we need to make the first request so we don't show the empty
      // state without knowing if there are any pipelines
      this.fetchPipelines();
    }

    visibilityjs_default.a.change(function () {
      if (!visibilityjs_default.a.hidden()) {
        _this.poll.restart();
      } else {
        _this.poll.stop();
      }
    });

    event_hub["a" /* default */].$on('refreshPipelines', this.fetchPipelines);
    event_hub["a" /* default */].$on('postAction', this.postAction);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('refreshPipelines');
    event_hub["a" /* default */].$on('postAction', this.postAction);
  },
  destroyed: function destroyed() {
    this.poll.stop();
  },

  methods: {
    fetchPipelines: function fetchPipelines() {
      var _this2 = this;

      if (!this.isMakingRequest) {
        this.isLoading = true;

        this.service.getPipelines(this.requestData).then(function (response) {
          return _this2.successCallback(response);
        }).catch(function () {
          return _this2.errorCallback();
        });
      }
    },
    setCommonData: function setCommonData(pipelines) {
      this.store.storePipelines(pipelines);
      this.isLoading = false;
      this.updateGraphDropdown = true;
      this.hasMadeRequest = true;
    },
    errorCallback: function errorCallback() {
      this.hasError = true;
      this.isLoading = false;
      this.updateGraphDropdown = false;
    },
    setIsMakingRequest: function setIsMakingRequest(isMakingRequest) {
      this.isMakingRequest = isMakingRequest;

      if (isMakingRequest) {
        this.updateGraphDropdown = false;
      }
    },
    postAction: function postAction(endpoint) {
      this.service.postAction(endpoint).then(function () {
        return event_hub["a" /* default */].$emit('refreshPipelines');
      }).catch(function () {
        return new flash["a" /* default */]('An error occurred while making the request.');
      });
    }
  }
});

/***/ }),

/***/ "./pipelines/pipelines_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: ./pipelines/stores/pipelines_store.js
var pipelines_store = __webpack_require__("./pipelines/stores/pipelines_store.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: ./pipelines/services/pipelines_service.js
var pipelines_service = __webpack_require__("./pipelines/services/pipelines_service.js");

// EXTERNAL MODULE: ./pipelines/mixins/pipelines.js + 33 modules
var pipelines = __webpack_require__("./pipelines/mixins/pipelines.js");

// EXTERNAL MODULE: ./vue_shared/components/table_pagination.vue + 2 modules
var table_pagination = __webpack_require__("./vue_shared/components/table_pagination.vue");

// EXTERNAL MODULE: ./vue_shared/components/navigation_tabs.vue + 1 modules
var navigation_tabs = __webpack_require__("./vue_shared/components/navigation_tabs.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/nav_controls.vue

/* harmony default export */ var nav_controls = ({
  name: 'PipelineNavControls',
  props: {
    newPipelinePath: {
      type: String,
      required: true
    },

    hasCiEnabled: {
      type: Boolean,
      required: true
    },

    helpPagePath: {
      type: String,
      required: true
    },

    resetCachePath: {
      type: String,
      required: true
    },

    ciLintPath: {
      type: String,
      required: true
    },

    canCreatePipeline: {
      type: Boolean,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c6fd384","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/nav_controls.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-controls"},[(_vm.canCreatePipeline)?_c('a',{staticClass:"btn btn-create",attrs:{"href":_vm.newPipelinePath}},[_vm._v("\n    运行流水线\n  ")]):_vm._e(),_vm._v(" "),(!_vm.hasCiEnabled)?_c('a',{staticClass:"btn btn-info",attrs:{"href":_vm.helpPagePath}},[_vm._v("\n    开始使用流水线\n  ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-default",attrs:{"data-method":"post","rel":"nofollow","href":_vm.resetCachePath}},[_vm._v("\n    Clear runner caches\n  ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-default",attrs:{"href":_vm.ciLintPath}},[_vm._v("\n    CI Lint\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_nav_controls = (esExports);
// CONCATENATED MODULE: ./pipelines/components/nav_controls.vue
var normalizeComponent = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  nav_controls,
  components_nav_controls,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pipelines_components_nav_controls = (Component.exports);

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// EXTERNAL MODULE: ./vue_shared/mixins/ci_pagination_api_mixin.js
var ci_pagination_api_mixin = __webpack_require__("./vue_shared/mixins/ci_pagination_api_mixin.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines.vue










/* harmony default export */ var components_pipelines = ({
  components: {
    tablePagination: table_pagination["a" /* default */],
    navigationTabs: navigation_tabs["a" /* default */],
    navigationControls: pipelines_components_nav_controls
  },
  mixins: [pipelines["a" /* default */], ci_pagination_api_mixin["a" /* default */]],
  props: {
    store: {
      type: Object,
      required: true
    },
    // Can be rendered in 3 different places, with some visual differences
    // Accepts root | child
    // `root` -> main view
    // `child` -> rendered inside MR or Commit View
    viewType: {
      type: String,
      required: false,
      default: 'root'
    }
  },
  data: function data() {
    var pipelinesData = document.querySelector('#pipelines-list-vue').dataset;

    return {
      endpoint: pipelinesData.endpoint,
      helpPagePath: pipelinesData.helpPagePath,
      emptyStateSvgPath: pipelinesData.emptyStateSvgPath,
      errorStateSvgPath: pipelinesData.errorStateSvgPath,
      autoDevopsPath: pipelinesData.helpAutoDevopsPath,
      newPipelinePath: pipelinesData.newPipelinePath,
      canCreatePipeline: pipelinesData.canCreatePipeline,
      hasCi: pipelinesData.hasCi,
      ciLintPath: pipelinesData.ciLintPath,
      resetCachePath: pipelinesData.resetCachePath,
      state: this.store.state,
      scope: Object(common_utils["g" /* getParameterByName */])('scope') || 'all',
      page: Object(common_utils["g" /* getParameterByName */])('page') || '1',
      requestData: {}
    };
  },

  computed: {
    canCreatePipelineParsed: function canCreatePipelineParsed() {
      return Object(common_utils["d" /* convertPermissionToBoolean */])(this.canCreatePipeline);
    },


    /**
    * The empty state should only be rendered when the request is made to fetch all pipelines
    * and none is returned.
    *
    * @return {Boolean}
    */
    shouldRenderEmptyState: function shouldRenderEmptyState() {
      return !this.isLoading && !this.hasError && this.hasMadeRequest && !this.state.pipelines.length && (this.scope === 'all' || this.scope === null);
    },

    /**
     * When a specific scope does not have pipelines we render a message.
     *
     * @return {Boolean}
     */
    shouldRenderNoPipelinesMessage: function shouldRenderNoPipelinesMessage() {
      return !this.isLoading && !this.hasError && !this.state.pipelines.length && this.scope !== 'all' && this.scope !== null;
    },
    shouldRenderTable: function shouldRenderTable() {
      return !this.hasError && !this.isLoading && this.state.pipelines.length;
    },

    /**
    * Pagination should only be rendered when there is more than one page.
    *
    * @return {Boolean}
    */
    shouldRenderPagination: function shouldRenderPagination() {
      return !this.isLoading && this.state.pipelines.length && this.state.pageInfo.total > this.state.pageInfo.perPage;
    },
    hasCiEnabled: function hasCiEnabled() {
      return this.hasCi !== undefined;
    },
    tabs: function tabs() {
      var count = this.state.count;

      return [{
        name: 'All',
        scope: 'all',
        count: count.all,
        isActive: this.scope === 'all'
      }, {
        name: 'Pending',
        scope: 'pending',
        count: count.pending,
        isActive: this.scope === 'pending'
      }, {
        name: 'Running',
        scope: 'running',
        count: count.running,
        isActive: this.scope === 'running'
      }, {
        name: 'Finished',
        scope: 'finished',
        count: count.finished,
        isActive: this.scope === 'finished'
      }, {
        name: 'Branches',
        scope: 'branches',
        isActive: this.scope === 'branches'
      }, {
        name: 'Tags',
        scope: 'tags',
        isActive: this.scope === 'tags'
      }];
    }
  },
  created: function created() {
    this.service = new pipelines_service["a" /* default */](this.endpoint);
    this.requestData = { page: this.page, scope: this.scope };
  },

  methods: {
    successCallback: function successCallback(resp) {
      var _this = this;

      return resp.json().then(function (response) {
        // Because we are polling & the user is interacting verify if the response received
        // matches the last request made
        if (underscore_default.a.isEqual(Object(common_utils["w" /* parseQueryStringIntoObject */])(resp.url.split('?')[1]), _this.requestData)) {
          _this.store.storeCount(response.count);
          _this.store.storePagination(resp.headers);
          _this.setCommonData(response.pipelines);
        }
      });
    },

    /**
     * Handles URL and query parameter changes.
     * When the user uses the pagination or the tabs,
     *  - update URL
     *  - Make API request to the server with new parameters
     *  - Update the polling function
     *  - Update the internal state
     */
    updateContent: function updateContent(parameters) {
      var _this2 = this;

      this.updateInternalState(parameters);

      // fetch new data
      return this.service.getPipelines(this.requestData).then(function (response) {
        _this2.isLoading = false;
        _this2.successCallback(response);

        // restart polling
        _this2.poll.restart({ data: _this2.requestData });
      }).catch(function () {
        _this2.isLoading = false;
        _this2.errorCallback();

        // restart polling
        _this2.poll.restart();
      });
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-329bef2f","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines.vue
var pipelines_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pipelines-container"},[(!_vm.shouldRenderEmptyState)?_c('div',{staticClass:"top-area scrolling-tabs-container inner-page-scroll-tabs"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('navigation-tabs',{attrs:{"tabs":_vm.tabs,"scope":"pipelines"},on:{"onChangeTab":_vm.onChangeTab}}),_vm._v(" "),_c('navigation-controls',{attrs:{"new-pipeline-path":_vm.newPipelinePath,"has-ci-enabled":_vm.hasCiEnabled,"help-page-path":_vm.helpPagePath,"reset-cache-path":_vm.resetCachePath,"ci-lint-path":_vm.ciLintPath,"can-create-pipeline":_vm.canCreatePipelineParsed}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content-list pipelines"},[(_vm.isLoading)?_c('loading-icon',{staticClass:"prepend-top-20",attrs:{"label":"正在载入流水线","size":"3"}}):_vm._e(),_vm._v(" "),(_vm.shouldRenderEmptyState)?_c('empty-state',{attrs:{"help-page-path":_vm.helpPagePath,"empty-state-svg-path":_vm.emptyStateSvgPath}}):_vm._e(),_vm._v(" "),(_vm.shouldRenderErrorState)?_c('error-state',{attrs:{"error-state-svg-path":_vm.errorStateSvgPath}}):_vm._e(),_vm._v(" "),(_vm.shouldRenderNoPipelinesMessage)?_c('div',{staticClass:"blank-state-row"},[_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.shouldRenderTable)?_c('div',{staticClass:"table-holder"},[_c('pipelines-table-component',{attrs:{"pipelines":_vm.state.pipelines,"update-graph-dropdown":_vm.updateGraphDropdown,"auto-devops-help-path":_vm.autoDevopsPath,"view-type":_vm.viewType}})],1):_vm._e(),_vm._v(" "),(_vm.shouldRenderPagination)?_c('table-pagination',{attrs:{"change":_vm.onChangePage,"page-info":_vm.state.pageInfo}}):_vm._e()],1)])}
var pipelines_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fade-left"},[_c('i',{staticClass:"fa fa-angle-left",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fade-right"},[_c('i',{staticClass:"fa fa-angle-right",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blank-state-center"},[_c('h2',{staticClass:"blank-state-title js-blank-state-title"},[_vm._v("没有流水线可显示。")])])}]
var pipelines_esExports = { render: pipelines_render, staticRenderFns: pipelines_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_pipelines_components_pipelines = (pipelines_esExports);
// CONCATENATED MODULE: ./pipelines/components/pipelines.vue
var pipelines_normalizeComponent = __webpack_require__("../../../node_modules/vue-loader/lib/component-normalizer.js")
/* script */


/* template */

/* template functional */
var pipelines___vue_template_functional__ = false
/* styles */
var pipelines___vue_styles__ = null
/* scopeId */
var pipelines___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines___vue_module_identifier__ = null
var pipelines_Component = pipelines_normalizeComponent(
  components_pipelines,
  selectortype_template_index_0_pipelines_components_pipelines,
  pipelines___vue_template_functional__,
  pipelines___vue_styles__,
  pipelines___vue_scopeId__,
  pipelines___vue_module_identifier__
)

/* harmony default export */ var pipelines_components_pipelines = (pipelines_Component.exports);

// EXTERNAL MODULE: ./vue_shared/translate.js
var translate = __webpack_require__("./vue_shared/translate.js");

// CONCATENATED MODULE: ./pipelines/pipelines_bundle.js





vue_esm["a" /* default */].use(translate["a" /* default */]);

document.addEventListener('DOMContentLoaded', function () {
  return new vue_esm["a" /* default */]({
    el: '#pipelines-list-vue',
    components: {
      pipelinesComponent: pipelines_components_pipelines
    },
    data: function data() {
      var store = new pipelines_store["a" /* default */]();

      return {
        store: store
      };
    },
    render: function render(createElement) {
      return createElement('pipelines-component', {
        props: {
          store: this.store
        }
      });
    }
  });
});

/***/ }),

/***/ "./pipelines/services/pipelines_service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("../../../node_modules/vue-resource/dist/vue-resource.esm.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

var PipelinesService = function () {

  /**
  * Commits and merge request endpoints need to be requested with `.json`.
  *
  * The url provided to request the pipelines in the new merge request
  * page already has `.json`.
  *
  * @param  {String} root
  */
  function PipelinesService(root) {
    _classCallCheck(this, PipelinesService);

    var endpoint = void 0;

    if (root.indexOf('.json') === -1) {
      endpoint = root + '.json';
    } else {
      endpoint = root;
    }

    this.pipelines = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].resource(endpoint);
  }

  _createClass(PipelinesService, [{
    key: 'getPipelines',
    value: function getPipelines() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var scope = data.scope,
          page = data.page;

      return this.pipelines.get({ scope: scope, page: page });
    }

    /**
     * Post request for all pipelines actions.
     *
     * @param  {String} endpoint
     * @return {Promise}
     */

  }, {
    key: 'postAction',
    value: function postAction(endpoint) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(endpoint + '.json');
    }
  }]);

  return PipelinesService;
}();

/* harmony default export */ __webpack_exports__["a"] = (PipelinesService);

/***/ }),

/***/ "./pipelines/stores/pipelines_store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PipelinesStore = function () {
  function PipelinesStore() {
    _classCallCheck(this, PipelinesStore);

    this.state = {};

    this.state.pipelines = [];
    this.state.count = {};
    this.state.pageInfo = {};
  }

  _createClass(PipelinesStore, [{
    key: 'storePipelines',
    value: function storePipelines() {
      var pipelines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.state.pipelines = pipelines;
    }
  }, {
    key: 'storeCount',
    value: function storeCount() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.state.count = count;
    }
  }, {
    key: 'storePagination',
    value: function storePagination() {
      var pagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var paginationInfo = void 0;

      if (Object.keys(pagination).length) {
        var normalizedHeaders = Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["u" /* normalizeHeaders */])(pagination);
        paginationInfo = Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["v" /* parseIntPagination */])(normalizedHeaders);
      } else {
        paginationInfo = pagination;
      }

      this.state.pageInfo = paginationInfo;
    }
  }]);

  return PipelinesStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (PipelinesStore);

/***/ })

},["./pipelines/pipelines_bundle.js"]);


// WEBPACK FOOTER //
// pipelines.031ebe2ed45a52ed515d.bundle.js